import type { Behavior, Stage } from '@capture/shared';
import { validBehaviorsForStage } from '@capture/shared';

export function defaultBehaviorForKind(kind: Behavior['kind']): Behavior {
  switch (kind) {
    case 'populate': return { kind: 'populate', source: { type: 'literal', value: '' } };
    case 'transform': return { kind: 'transform', op: 'uppercase', params: {} };
    case 'compute': return { kind: 'compute', formula: { source: '' }, dependsOn: [] };
    case 'substitute': return { kind: 'substitute', when: { op: 'eq', args: ['', ''] }, value: { source: '' } };
    case 'display': return { kind: 'display', mode: 'editable' };
    case 'parse': return { kind: 'parse', parser: 'name', targets: { last: '', first: '', middle: '' }, editMode: 'parts' };
    case 'emit': return { kind: 'emit', destinations: 'all' };
    // transform-webhook T5 — seeds an empty-but-valid WebhookBehaviorConfig.
    // requestBody/responseMappings start empty (T5 only builds the request
    // side; T6 adds response-mapping authoring) and failMode defaults to
    // 'soft', mirroring the WU-3.2 webhook_validate rule's default.
    case 'webhook': return { kind: 'webhook', url: '', requestBody: [], responseMappings: [], failMode: 'soft' };
  }
}

export function pickableForStage(stage: Stage): Behavior['kind'][] {
  return [...validBehaviorsForStage(stage)];
}

/** Operator-facing label for a pickable behavior kind — the "Add behavior"
 *  picker (StageSection) shows this instead of the bare kind string when one
 *  is registered here. Kinds absent from this map fall back to the bare
 *  kind name (existing behavior, unchanged). */
const BEHAVIOR_KIND_LABELS: Partial<Record<Behavior['kind'], string>> = {
  webhook: 'Webhook (external lookup/calc)',
};

export function behaviorKindLabel(kind: Behavior['kind']): string {
  return BEHAVIOR_KIND_LABELS[kind] ?? kind;
}
